var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g(_vm._b({staticClass:"p-btn",class:{
    [`p-btn-${_vm.variant}`]: true,
    'w-100': _vm.fullWidth,
    'btn-loading': _vm.loading,
    'position-relative': _vm.withPills
  },attrs:{"type":_vm.type,"disabled":_vm.loading || _vm.disabled}},'button',_vm.$attrs,false),_vm.$listeners),[_vm._t("default"),_vm._v(" "),(_vm.withPills)?_c('div',{staticClass:"position-absolute top-50 start-100 translate-middle"},[_c('pills',_vm._b({staticStyle:{"outline":"2px solid white"}},'pills',_vm.pillsProps,false),[_vm._v("\n      "+_vm._s(_vm.pillsText)+"\n    ")])],1):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }